import { useLocation } from "react-router-dom";
import { useAuth } from "./auth/AuthContext";
import Login from "./routes/Login";
import ResetPassword from "./routes/ResetPassword";
import Portal from "./portal/Portal";

function Splash({ label }: { label: string }) {
  return (
    <div className="login">
      <span className="muted">{label}</span>
    </div>
  );
}

export default function App() {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();

  // The emailed reset / set-password link lands here regardless of auth state.
  if (pathname === "/reset") return <ResetPassword />;

  if (loading) return <Splash label="Loading…" />;
  if (!user) return <Login />;
  return <Portal />;
}
